import './index.scss'
if ( window.innerWidth> 1024) {
    $(window).on('scroll', function() {
        var scrollPosition = $(window).scrollTop(); // 获取当前滚动位置
        var modulePosition = $('.news').offset().top; // 获取目标模块的顶部位置
        var moduleHeight = $('.news').outerHeight(); // 获取模块的高度（如果需要检测到达底部）
         var windowHeight = $(window).height(); // 获取视口高度（可选，用于更复杂的检测）
        // 检查是否滚动到了模块的顶部或底部（根据需要选择）
        if (scrollPosition >= modulePosition - $("header").height()  && scrollPosition < $("footer").offset().top - windowHeight) { // 到达顶部（可根据需要调整距离）
            $(".news .left .content").addClass("fixed");
             $(".news .left .content").removeClass("fixed1");
            // 在这里执行你的代码，例如调用一个函数或执行动画等
            
            
        }
       else if (scrollPosition >= $("footer").offset().top - windowHeight && $("footer").offset().top) {
           $(".news .left .content").removeClass("fixed");
            $(".news .left .content").addClass("fixed1");
            
        }
        else{
            $(".news .left .content").removeClass("fixed");
             $(".news .left .content").removeClass("fixed1");
            // 在这里执行你的代码，例如调用一个函数或执行动画等
            
        }

        
    });
}